/* eslint-disable init-declarations, no-unused-expressions, no-sequences, no-use-before-define, one-var, @typescript-eslint/no-this-alias, prefer-rest-params*/
export default (a, b, c) => {
  let d, e
  return function () {
    function h() {
      ;(d = null), c || (e = a.apply(f, g))
    }
    const f = this,
      g = arguments
    return (
      clearTimeout(d), (d = setTimeout(h, b)), c && !d && (e = a.apply(f, g)), e
    )
  }
}
